export const LOAD_PRODUCTS = 'LOAD_PRODUCTS';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const LOAD_TEMPLATES = 'LOAD_TEMPLATES';
export const SET_TEMPLATES = 'SET_TEMPLATES';
export const SET_TEMPLATEPRODUCTS = 'SET_TEMPLATEPRODUCTS';
export const SET_ALTERNATIVEOPTIONS = 'SET_ALTERNATIVEOPTIONS';
export const SET_CURRENTTEMPLATE = 'SET_CURRENTTEMPLATE';
export const UPDATE_CURRENTTEMPLATEPRODUCTS = 'UPDATE_CURRENTTEMPLATEPRODUCTS';
export const SET_ALTERNATIVEOPTIONSTEMPlATE = 'SET_ALTERNATIVEOPTIONSTEMPlATE';
export const UPDATE_CURRENTTEMPLATEOPTIONS = 'UPDATE_CURRENTTEMPLATEOPTIONS';